var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ChangeDetectorRef } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { AuthenticationService } from "../../services/authentication.service";
import { HttpParams } from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CALENDAR_LOCALE } from '../../services/constant';
import { TemplateService } from "../../services/template.service";
import { TranslateService } from '@ngx-translate/core';
var BulkTaxReportComponent = (function () {
    function BulkTaxReportComponent(apiService, modalService, cdr, authService, template, translate) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.cdr = cdr;
        this.authService = authService;
        this.template = template;
        this.translate = translate;
        this.itemsPerPage = 40;
        this.allDeliverycode = true;
        this.allDocType = true;
        this.allDocumentType = [];
        this.allDeliverycodeSelected = [];
        this.selectedValues = [];
        this.currentPage = 1;
        this.loading = false;
        this.no_data = true;
        this.errorMsg = '';
        this.loadingExcel = false;
        this.loadingAllExcel = false;
        this.cofirm_loading = false;
        this.deliverycodeList = null;
        this.allDeliverycodeList = null;
        this.docTypeList = null;
        this.defaultLabel = null;
        this.keepexcel = [];
        this.checkAll = false;
        this.loadingAll = false;
        this.no_dataAll = true;
        this.tableCol = [];
        this.is_TH = false;
    }
    // ngOnInit() {
    //   this.loadTexts();
    //   this.pageChanged();
    //   this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
    //     if (event.lang === 'th') {
    //       this.is_TH = true;
    //     }
    //     if (event.lang === 'en') {
    //       this.is_TH = false;
    //     }
    //     this.loadTexts();
    //   });
    // }
    BulkTaxReportComponent.prototype.ngOnInit = function () {
        var _this = this;
        // this.loadDropdown();
        // this.loadInput();
        //   this.pageChanged();
        this.translate.onLangChange.subscribe(function (event) {
            _this.loadTexts();
        });
        this.loadTexts();
        this.rdDocumentType = this.template.getDropdown();
        this.rdDocumentType.splice(0, 0, { label: this.translate.instant('COMMON.ALL'), value: null });
    };
    BulkTaxReportComponent.prototype.loadTexts = function () {
        var _this = this;
        this.defaultLabel = this.translate.instant('COMMON.ALL');
        this.tableCol = [];
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
        this.translate.get('FILTER.DATE').subscribe(function (res) {
            _this.tableCol.push(
            // { field: 'group', header: 'Business' },
            { field: 'customer_code', header: _this.translate.instant('FILTER.CUSTOMER-CODE') }, { field: 'delivery_code', header: _this.translate.instant('FILTER.DELIVERY-CODE') }, { field: 'branch', header: _this.translate.instant('TABLE.BRANCH-NAME') }, { field: 'rd_doc_type', header: _this.translate.instant('FILTER.DOCUMENT-TYPE') }, 
            // { field: 'doc_type', header: 'ประเภทเอกสารในองค์กร' },
            { field: 'start_end_document', header: _this.translate.instant('TABLE.DOCUMENT-NUMBER-START-END') }, { field: 'total_doc', header: _this.translate.instant('TABLE.NUMBER-DOCUMENTS') }, { field: 'total_missing_doc', header: _this.translate.instant('TABLE.NUMBER-MISSING-DOCUMENTS') }, { field: 'non_vat', header: _this.translate.instant('TABLE.SALES') + ' Non-VAT' }, { field: 'vat', header: 'VAT' }, { field: 'total_payment', header: _this.translate.instant('TABLE.SALES') + ' VAT' });
            var documentData = _this.template.getDropdown();
            documentData.splice(0, 0, { label: _this.translate.instant('COMMON.ALL'), value: null });
            _this.rdDocumentType = documentData;
            _this.tableCol = _.uniqBy(_this.tableCol, 'field');
            _this.loadInput();
        });
    };
    Object.defineProperty(BulkTaxReportComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (2020) + ':' + (thisYear);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BulkTaxReportComponent.prototype, "dateRange", {
        get: function () {
            var start = moment(this.startDate).format('DD/MM/YYYY');
            var end = moment(this.endDate).format('DD/MM/YYYY');
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    BulkTaxReportComponent.prototype.ngAfterViewChecked = function () {
        this.cdr.detectChanges();
    };
    BulkTaxReportComponent.prototype.loadInput = function () {
        var _this = this;
        this.customercode = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        var params = new HttpParams();
        params = params.append('none_pagination', 'true');
        this.apiService.getCustomerList(params).subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.customercode.push({
                    label: obj.c_code,
                    value: obj.id
                });
            });
            _this.customercode = _.uniqBy(_this.customercode, 'label');
        }, function (error) {
            console.log('error', error);
        });
        this.homeproGroup = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.apiService.getCompanyGroup().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.homeproGroup.push({
                    label: obj.name,
                    value: obj.id
                });
            });
        });
        this.apiService.getDeliveryList().subscribe(function (result) {
            _this.allDeliverycodeList = result;
            _this.filterDeliverycodeList();
        });
        this.startDate = new Date();
        this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
        this.endDate = new Date();
        this.selectedCustomercode = null;
        this.selectedRdDocumentType = null;
    };
    BulkTaxReportComponent.prototype.filterDeliverycodeList = function () {
        var _this = this;
        this.selectedDeliverycode = null;
        this.deliverycodeList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        _.forEach(this.allDeliverycodeList, function (obj) {
            if (_this.selectedCustomercode == null || obj.d_custcode == _this.selectedCustomercode)
                _this.deliverycodeList.push({
                    label: obj.d_code,
                    value: obj.id
                });
        });
    };
    BulkTaxReportComponent.prototype.pageChanged = function () {
        var params = new HttpParams().set('page', _.toString(this.currentPage));
        this.checkAll = false;
        this.deselectAll();
        this.searchData(params);
    };
    BulkTaxReportComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        if (!this.no_data) {
            this.table.reset();
        }
        this.searchData();
    };
    BulkTaxReportComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
        if (this.endDate < this.minDate) {
            this.endDate = this.minDate;
        }
    };
    BulkTaxReportComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
        if (this.startDate > this.maxDate) {
            this.startDate = this.maxDate;
        }
    };
    BulkTaxReportComponent.prototype.canUserApproveDoc = function () {
        return this.authService.isAccountant() || this.authService.isAdmin() || this.authService.isUIH();
    };
    BulkTaxReportComponent.prototype.searchDeliverycode = function (event) {
        var _this = this;
        if (this.deliverycodeList == null) {
            this.apiService.getDeliveryList().subscribe(function (data) {
                _this.deliverycodeList = data;
                _this.deliverycodeSuggest = _this.filterData(event.query, 'd_code', _this.deliverycodeList);
            });
        }
        else {
            this.deliverycodeSuggest = this.filterData(event.query, 'd_code', this.deliverycodeList);
        }
    };
    BulkTaxReportComponent.prototype.searchDocumentType = function (event) {
        var _this = this;
        if (this.docTypeList == null) {
            this.apiService.getDocumentType().subscribe(function (result) {
                _this.docTypeList = result;
                _this.typeSuggest = _this.filterData(event.query, 'type', _this.docTypeList);
            });
        }
        else {
            this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
        }
    };
    BulkTaxReportComponent.prototype.filterData = function (query, field, dataList) {
        query = query.toLowerCase().trim();
        var filtered = [];
        for (var i = 0; i < dataList.length; i++) {
            var data = dataList[i];
            if (data[field].toLowerCase().indexOf(query) >= 0) {
                filtered.push(data);
            }
        }
        return filtered;
    };
    BulkTaxReportComponent.prototype.selectAllDeliverycode = function () {
        this.deliverycode = null;
    };
    BulkTaxReportComponent.prototype.selectDocType = function () {
        this.documentType = null;
    };
    BulkTaxReportComponent.prototype.searchData = function (params) {
        var _this = this;
        this.loading = true;
        this.checkCondition();
        if (this.errorMsg.length > 0) {
            this.loading = false;
            return;
        }
        this.allDeliverycodeSelected = [];
        this.allDocumentType = [];
        _.forEach(this.deliverycode, function (data) {
            // this.allDeliverycodeSelected = [];
            _this.allDeliverycodeSelected.push(_.toNumber(data.id));
        });
        _.forEach(this.documentType, function (data) {
            // this.allDocumentType = [];
            _this.allDocumentType.push(_.toNumber(data.id));
        });
        var data = {
            not_approved_only: this.notApprove,
            header_issue_date_start: moment(this.startDate).format('YYYY-MM-DD'),
            header_issue_date_end: moment(this.endDate).format('YYYY-MM-DD'),
            corporate_group_id: this.selectedHomeproGroup,
            customercode_id: this.selectedCustomercode,
            document_type_id: (_.isNil(this.documentType)) ? this.documentType : _.uniq(this.allDocumentType),
            //branch_id: (_.isNil(this.branch)) ? this.branch : _.uniq(this.allBranchSelected),
            deliverycode_id: this.selectedDeliverycode ? this.selectedDeliverycode : null,
            items_per_page: this.itemsPerPage,
            rd_doc_type: this.selectedRdDocumentType
        };
        if (this.sortBy && this.sortMode) {
            data['sort'] = this.sortBy;
            data['sort_type'] = this.sortMode;
        }
        if (this.currentPage === 1) {
            params = null;
        }
        this.apiService.postBulkSaleTax(data, params).subscribe(function (result) {
            _this.loading = false;
            _this.tableData = result.results;
            _this.no_data = _.isEmpty(_this.tableData);
            _this.totalItems = result.count;
        }, function (error) {
            _this.loading = false;
            _this.no_data = true;
            _this.errorMsg = _this.translate.instant('ERROR.TRY-AGAIN');
        });
    };
    BulkTaxReportComponent.prototype.confirmDocument = function (event, content, index) {
        // event.currentTarget.blur();
        document.getElementById('chkbox' + index).blur();
        event.preventDefault();
        this.modalData = this.tableData[index];
        this.modal = this.modalService.open(content, { backdrop: 'static', keyboard: false });
    };
    BulkTaxReportComponent.prototype.confirm = function () {
        var _this = this;
        this.cofirm_loading = true;
        var params = {
            approved: this.modalData.approved,
            header_issue_date: this.modalData.header_issue_date,
            group: this.modalData.group,
            document_type: this.modalData.document_type,
            rd_document_type: this.modalData.rd_document_type,
            corporate_branch: this.modalData.corporate_branch,
        };
        this.apiService.approveSale(params).subscribe(function (result) {
            _this.cofirm_loading = false;
            _this.modal.close();
            _this.modal = null;
        }, function (error) {
            _this.cofirm_loading = false;
        });
    };
    BulkTaxReportComponent.prototype.revertBack = function () {
        this.modalData.approved = !this.modalData.approved;
        this.modal.close();
        this.modal = null;
    };
    BulkTaxReportComponent.prototype.clearData = function () {
        this.tableData = undefined;
        this.no_data = true;
        this.startDate = new Date();
        this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
        this.endDate = new Date();
        this.selectedCustomercode = null;
        this.selectedDeliverycode = null;
        this.selectedRdDocumentType = null;
        this.deliverycode = null;
        this.documentType = null;
        this.notApprove = false;
        this.allDocType = true;
        this.allDeliverycode = true;
        this.sortBy = null;
        this.sortMode = null;
        this.selectedValues = [];
        this.keepexcel = [];
        this.searchButtonClicked();
    };
    BulkTaxReportComponent.prototype.getExportDocs = function (data, index) {
        var _this = this;
        //this.loadingAllExcel[index] = true;
        this.tableData[index].loading_all_docs_excel = true;
        var params = {
            header_issue_date_start: moment(this.startDate).format('YYYY-MM-DD'),
            header_issue_date_end: moment(this.endDate).format('YYYY-MM-DD'),
            document_type: data.document_type,
            rd_document_type: data.rd_document_type,
            corporate_branch: data.corporate_branch,
            group: data.group,
            delivery_code: data.delivery_code,
            customer_code: data.customer_code,
            lang: this.translate.currentLang
        };
        this.apiService.getBulkAllDocs(params).subscribe(function (obj) {
            _this.tableData[index].loading_all_docs_excel = false;
            var filename = 'bulk_report ' + params.header_issue_date_start + ' - ' + params.header_issue_date_end + '.xlsx';
            _this.apiService.createDownloadFile(obj, filename);
            _this.apiService.triggerLog({
                'log_type': 'DOWNLOAD_EXCEL',
                'action_issue': 'BULK_TAX_REPORT',
                'description': params.rd_document_type + " cc: " + params.customer_code + " dc: " + params.delivery_code + " date: " + params.header_issue_date_start + " - " + params.header_issue_date_end
            }).subscribe();
            // data.xmlLoading = false;
        }, function (error) {
            _this.tableData[index].loading_all_docs_excel = false;
            // data.xmlLoading = false;
        });
    };
    BulkTaxReportComponent.prototype.downloadMissingDocs = function (data, index) {
        var _this = this;
        this.tableData[index].loading_missing_docs_excel = true;
        // data.xmlLoading = true;
        var params = {
            header_issue_date_start: moment(this.startDate).format('YYYY-MM-DD'),
            header_issue_date_end: moment(this.endDate).format('YYYY-MM-DD'),
            document_type: data.document_type,
            rd_document_type: data.rd_document_type,
            corporate_branch: data.corporate_branch,
            max_document: data.max_document,
            min_document: data.min_document,
            group: data.group,
            delivery_code: data.delivery_code,
            customer_code: data.customer_code,
            lang: this.translate.currentLang
        };
        this.apiService.getBulkMissingDoc(params).subscribe(function (obj) {
            _this.tableData[index].loading_missing_docs_excel = false;
            var filename = 'bulk_missing ' + params.header_issue_date_start + ' - ' + params.header_issue_date_end + '.xlsx';
            _this.apiService.createDownloadFile(obj, filename);
            // this.apiService.triggerLog({'log_type': 'DOWNLOAD_EXCEL'}).subscribe();
            // data.xmlLoading = false;
        }, function (error) {
            _this.tableData[index].loading_missing_docs_excel = false;
            // data.xmlLoading = false;
        });
    };
    BulkTaxReportComponent.prototype.clearDeliverycode = function () {
        this.allDeliverycodeSelected = [];
    };
    BulkTaxReportComponent.prototype.clearDocType = function () {
        this.allDocumentType = [];
    };
    BulkTaxReportComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    BulkTaxReportComponent.prototype.checkCondition = function () {
        this.errorMsg = '';
        var errorMsgList = [];
        if (_.isEmpty(this.deliverycode) && this.allDeliverycode === false) {
            errorMsgList.push(this.translate.instant('FILTER.DELIVERY-CODE'));
        }
        if (_.isEmpty(this.documentType) && this.allDocType === false) {
            errorMsgList.push('Doc Type');
        }
        if (errorMsgList.length > 0) {
            this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' ' + this.translate.instant('COMMON.CORRECT');
            return;
        }
        // let dayDiff = Math.abs(moment(this.endDate).diff(moment(this.startDate), 'days'));
        // if (dayDiff > 60 && this.authService.isAccountant()) {
        //   this.errorMsg = "ไม่สามารถเลือกระยะเวลาเกิน 60 วัน";
        // }
    };
    BulkTaxReportComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = 'asc';
        }
        else {
            this.sortMode = 'desc';
        }
        // this.searchData();
    };
    BulkTaxReportComponent.prototype.selectDeselectAll = function (checked) {
        if (checked) {
            this.selectAll();
            this.checkAll = true;
            return;
        }
        this.deselectAll();
        this.checkAll = false;
    };
    BulkTaxReportComponent.prototype.selectAll = function () {
        var stratdate = [];
        this.keepexcel = [];
        for (var i = 0; i < this.tableData.length; i++) {
            this.selectedValues[i] = true;
            stratdate.push({ 'start': moment(this.startDate).format('YYYY-MM-DD') });
            this.keepexcel.push({
                'header_issue_date_start': stratdate[i].start,
                'header_issue_date_end': moment(this.endDate).format('YYYY-MM-DD'),
                'document_type': this.tableData[i].document_type,
                'rd_document_type': this.tableData[i].rd_document_type,
                'corporate_branch': this.tableData[i].corporate_branch,
                'group': this.tableData[i].group,
                'delivery_code': this.tableData[i].delivery_code,
                'customer_code': this.tableData[i].customer_code
            });
        }
    };
    BulkTaxReportComponent.prototype.deselectAll = function () {
        for (var i = 0; i < this.tableData.length; i++) {
            this.selectedValues[i] = false;
        }
        this.keepexcel = [];
    };
    BulkTaxReportComponent.prototype.fetchAllData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var data;
            return __generator(this, function (_a) {
                this.loadingAll = true;
                this.checkCondition();
                if (this.errorMsg.length > 0) {
                    this.loadingAll = false;
                    return [2 /*return*/];
                }
                this.allDeliverycodeSelected = [];
                this.allDocumentType = [];
                _.forEach(this.deliverycode, function (data) {
                    // this.allDeliverycodeSelected = [];
                    _this.allDeliverycodeSelected.push(_.toNumber(data.id));
                });
                _.forEach(this.documentType, function (data) {
                    // this.allDocumentType = [];
                    _this.allDocumentType.push(_.toNumber(data.id));
                });
                data = {
                    not_approved_only: this.notApprove,
                    header_issue_date_start: moment(this.startDate).format('YYYY-MM-DD'),
                    header_issue_date_end: moment(this.endDate).format('YYYY-MM-DD'),
                    corporate_group_id: this.selectedHomeproGroup,
                    customercode_id: this.selectedCustomercode,
                    document_type_id: (_.isNil(this.documentType)) ? this.documentType : _.uniq(this.allDocumentType),
                    deliverycode_id: this.selectedDeliverycode ? this.selectedDeliverycode : null,
                    items_per_page: this.totalItems,
                    rd_doc_type: this.selectedRdDocumentType
                };
                if (this.sortBy && this.sortMode) {
                    data['sort'] = this.sortBy;
                    data['sort_type'] = this.sortMode;
                }
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.apiService.postSaleTax(data).subscribe(function (result) {
                            _this.loadingAll = false;
                            _this.tableDataAll = result.results;
                            _this.no_dataAll = _.isEmpty(_this.tableDataAll);
                            resolve(result.results);
                        }, function (error) {
                            _this.loadingAll = false;
                            _this.no_dataAll = true;
                            _this.errorMsg = _this.translate.instant('ERROR.TRY-AGAIN');
                            reject(error);
                        });
                    })];
            });
        });
    };
    BulkTaxReportComponent.prototype.downloadAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var stratdate, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchAllData()];
                    case 1:
                        _a.sent();
                        stratdate = [];
                        this.keepexcel = [];
                        for (i = 0; i < this.tableDataAll.length; i++) {
                            stratdate.push({ 'start': moment(this.startDate).format('YYYY-MM-DD') });
                            this.keepexcel.push({
                                'header_issue_date_start': stratdate[i].start,
                                'header_issue_date_end': moment(this.endDate).format('YYYY-MM-DD'),
                                'document_type': this.tableDataAll[i].document_type,
                                'rd_document_type': this.tableDataAll[i].rd_document_type,
                                'corporate_branch': this.tableDataAll[i].corporate_branch,
                                'group': this.tableDataAll[i].group,
                                'delivery_code': this.tableDataAll[i].delivery_code,
                                'customer_code': this.tableDataAll[i].customer_code
                            });
                        }
                        this.downloadMerge();
                        return [2 /*return*/];
                }
            });
        });
    };
    BulkTaxReportComponent.prototype.EnabledDownloadSelected = function () {
        return this.selectedValues.filter(function (select) { return select === true; }).length > 0;
    };
    BulkTaxReportComponent.prototype.downloadMerge = function () {
        var _this = this;
        var excelData = [];
        this.keepexcel.forEach(function (data) {
            excelData.push({
                'header_issue_date_start': moment(_this.startDate).format('YYYY-MM-DD'),
                'header_issue_date_end': moment(_this.endDate).format('YYYY-MM-DD'),
                'document_type': data.document_type,
                'rd_document_type': data.rd_document_type,
                'corporate_branch': data.corporate_branch,
                'group': data.group,
                'delivery_code': data.delivery_code,
                'customer_code': data.customer_code
            });
        });
        var params = {
            lang: this.translate.currentLang,
            merged_data_list: excelData
        };
        this.apiService.getMergeBulkExcel(params).subscribe(function (obj) {
            // this.tableData[index].loading_missing_docs_excel = false;
            var filename = 'merge_bulk_report ' + '.xlsx';
            _this.apiService.createDownloadFile(obj, filename);
            params.merged_data_list.forEach(function (data) {
                _this.apiService.triggerLog({
                    'log_type': 'DOWNLOAD_EXCEL',
                    'action_issue': 'BULK_TAX_REPORT',
                    'description': data.rd_document_type + " cc: " + data.customer_code + " dc: " + data.delivery_code + " date: " + data.header_issue_date_start + " - " + data.header_issue_date_end
                }).subscribe();
            });
            // this.apiService.triggerLog({'log_type': 'DOWNLOAD_EXCEL'}).subscribe();
            // data.xmlLoading = false;
        }, function (error) {
            // this.tableData[index].loading_missing_docs_excel = false;
            // data.xmlLoading = false;
        });
    };
    BulkTaxReportComponent.prototype.downloadCheckbox = function () {
        this.keepexcel = [];
        for (var i = 0; i < this.selectedValues.length; i++) {
            if (!this.selectedValues[i])
                continue;
            this.keepexcel.push(this.tableData[i]);
        }
        if (!_.isEmpty(this.keepexcel)) {
        }
    };
    return BulkTaxReportComponent;
}());
export { BulkTaxReportComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/bulk-tax-report/bulk-tax-report.component.ts.pre-build-optimizer.js